import ApiService from "@/app/infrastructures/services/ApiService";
import { RevenueDashboardMapper } from "@/data/persistences/mappers/RevenueDashboardMapper";
import { RevenueDashboardEndpoint } from "../../endpoints/RevenueDashboardEndpoint";
import {
  CustomerLeaderboard,
  CustomerLeaderboardResponse,
  PosRevenueOverview,
  RevenueDashboardCustomerListRequest,
  RevenueOverviewApiRequest,
  RevenueBreakdownApiRequest,
  RevenueBreakdownData
} from "@/domain/entities/RevenueDashboard";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";

export class RevenueDashboardApiRepository {
  private service: ApiService;
  private mapper: RevenueDashboardMapper;
  private endpoints: RevenueDashboardEndpoint;

  constructor(
    service: ApiService,
    mapper: RevenueDashboardMapper,
    endpoints: RevenueDashboardEndpoint
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  async getRevenueOverview(
    params: RevenueOverviewApiRequest
  ): Promise<PosRevenueOverview> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getRevenueOverview(params)
    );

    return this.mapper.convertRevenueOverviewFromApi(resp);
  }

  async getCustomerLeaderboard(
    params: RevenueDashboardCustomerListRequest
  ): Promise<CustomerLeaderboardResponse> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getCustomerLeaderboard(params)
    );

    return this.mapper.convertCustomerLeaderboardFromApi(resp);
  }

  public async getProductTypes(search: string): Promise<ResponsePayloadV2> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getProductTypes(search, 1, 100),
      {}
    );
    return this.mapper.convertProductTypesFromApi(resp);
  }

  public async getRevenueBreakdown(
    params: RevenueBreakdownApiRequest
  ): Promise<RevenueBreakdownData> {
    const url = this.endpoints.getRevenueBreakdown(params);
    const resp = await this.service.invoke("get", url);
    return this.mapper.convertRevenueBreakdownFromApi(resp);
  }

  public async getDestinationCities(
    search: string,
    page: number,
    limit: number
  ): Promise<ResponsePayloadV2> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getDestinationCities(search, page, limit),
      {}
    );
    return this.mapper.convertCityListFromApi(resp);
  }

  public async getCommodities(
    search: string,
    page: number,
    limit: number
  ): Promise<ResponsePayloadV2> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getCommodities(search, page, limit),
      {}
    );
    return this.mapper.convertCommodityListFromApi(resp);
  }
}
